import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

const selectAlertsState = (state: RootState) => state.alerts;

export const selectAlertsMetadata = createSelector(
  [selectAlertsState],
  ({ page, pageSize, total }) => {
    return {
      page,
      pageSize,
      total,
    };
  },
);

export const selectAlerts = createSelector(
  [selectAlertsState],
  (alertsState) => alertsState.content ?? [],
);

export const selectUnreadAlertsCount = createSelector(
  [selectAlerts],
  (alerts) => alerts.filter((alert) => !alert.viewed).length,
);
